module.exports = __webpack_public_path__ + "img/icon_youtube_b.6ac5c9bd.svg";